export const WRAPPER_ID = 'cs-suggestions-wrapper';

export const CS_SEARCH_BAR_FORM_ID = 'cs-search-bar-form';
